import { render, staticRenderFns } from "./AmenitySelect.vue?vue&type=template&id=9b45287c&scoped=true&"
import script from "./AmenitySelect.vue?vue&type=script&lang=js&"
export * from "./AmenitySelect.vue?vue&type=script&lang=js&"
import style0 from "./AmenitySelect.vue?vue&type=style&index=0&id=9b45287c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b45287c",
  null
  
)

export default component.exports